module.exports = __webpack_public_path__ + "static/media/maddie mulloway 2.dc19e6d0.jpg";